import { useQuery } from 'react-query';

import { getAcrossVersionHashCodeConfig as queryFn } from 'api/endPoints/getAcrossVersionHashCodeConfig';

type AcrossVersionHashCodeConfigResponse = { configName: string; isSet: boolean };

export const useQueryGetAcrossVersionHashCodeConfig = ({ projectId }) => {
    return useQuery<AcrossVersionHashCodeConfigResponse[], QueryError>(
        ['useQueryGetAcrossVersionHashCodeConfig', projectId],
        () => queryFn(projectId),
        {
            enabled: Boolean(projectId),
        },
    );
};
